// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ahZyP","location":"Header_location__NjhZa"};